import { getQueryString, getQueryStringNoDecode } from '@/sem2';
import {
  toutiaoReportForMiniprogram,
  ucReport,
  getWxOpenlink,
  getMediaKey,
  getQR,
  getQYQRCode,
  postStockReport
} from '@/reportmedia';
import { encryptSecret } from '@/utils';
import Loading from '@/components/Loading/index';

let jumpUrl = null;
let p_no = null;

let callback =
  getQueryStringNoDecode('clickid') ||
  getQueryStringNoDecode('callback') ||
  getQueryStringNoDecode('uctrackid') ||
  getQueryStringNoDecode('bd_vid') ||
  getQueryStringNoDecode('qz_gdt') ||
  getQueryStringNoDecode('requestid') ||
  getQueryStringNoDecode('request_id') ||
  getQueryStringNoDecode('callback_param') ||
  getQueryStringNoDecode('gdt_vid') || // 微信
  'callbackDefault';

let mediaKey = '';
const clickid = getQueryString('clickid');
const creativeid = getQueryString('creativeid');
const hashId = getQueryString('hashId') || 'hashIdDefault';
const reporturl = encodeURIComponent(window.location.href);
const uctrackid = getQueryString('uctrackid');

function reportSensors(eventName, params) {
  // sa.track(eventName, params);
}

async function asyncGetMediaKey(curtime, nonce, checksum) {
  const { code, data } = await getMediaKey(curtime, nonce, checksum, {
    hashId,
    callback,
    link: encodeURIComponent(window.location.href)
  });
  mediaKey = data.mediaKey;
}

async function asyncOpenlink($loading) {
  await getQR({
    hashId,
    mediaKey
  });
}
async function asyncGetQYQRCode(qrcodeId) {
  const result = await getQYQRCode({
    hashId,
    mediaKey
  });
  if (result.code === 200) {
    qrcodeId.forEach((name) => {
      jQuery(name).attr('src', result.data.qrInfo.qrCodeUrl);
    });
  }
}

// ✅✅✅ 新增核心工具函数：【百分比/px 统一转实际px数值】
// 传数字=直接返回(px)，传百分比字符串=计算对应屏幕宽度的实际px值
function getRealSize(sizeVal) {
  if (typeof sizeVal === 'number') {
    return sizeVal; // 原逻辑：纯数字=px，直接返回
  }
  if (typeof sizeVal === 'string' && sizeVal.includes('%')) {
    // 核心：百分比转px，基于【屏幕可视宽度】计算，适配所有屏幕
    const percent = parseFloat(sizeVal) / 100;
    return window.innerWidth * percent;
  }
  return 256; // 默认兜底值，和原逻辑一致
}

async function asyncGetOpenlink(qrcodeId, qrcodeSize, customWidth) {
  const [{ data, serverTime }] = await Promise.all([
    getWxOpenlink({
      hashId,
      mediaKey,
      _extracallback: callback,
      _extrap_no: p_no
    })
  ]);
  qrcodeId.forEach((name) => {
    const qrob = customWidth
      ? {
          // ✅✅✅ 修改核心处1：解析宽高，兼容 百分比/数字
          width: getRealSize(qrcodeSize[name].width),
          height: getRealSize(qrcodeSize[name].height)
        }
      : {
          width: 256,
          height: 256
        };
    jQuery(name).qrcode({ ...qrob, text: data && data.link });
  });
  return serverTime;
}
function isMobileEnvironment() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

async function init({
  qrcodeId = ['qrcode'],
  qrcodeSize = {
    width: 256,
    height: 256
  },
  page_number,
  customWidth = false,
  isQrInfo = false, // 是否走即时出码
  needPostBlock = false, // 需要提交通配符
  blockParam = {}
}) {
  p_no = page_number;
  // 获取mediaKey
  const { CurTime, Nonce, CheckSum } = encryptSecret();
  await asyncGetMediaKey(CurTime, Nonce, CheckSum);
  if (isQrInfo) {
    await asyncOpenlink();
    asyncGetQYQRCode(qrcodeId);
  } else {
    asyncGetOpenlink(qrcodeId, qrcodeSize, customWidth);
  }
  if (needPostBlock) {
    // 需要提交通配符
    postStockReport({
      ...blockParam,
      mediaKey: mediaKey
    });
  }
}

function getMediaKeyValue() {
  return mediaKey;
}

export default init;
export { getMediaKeyValue };
